import { useState } from 'react';
import MChevronDownIcon from '@/assets/manifold-icons/chevron-down.svg';

interface AccordionSectionProps {
  title: string | React.ReactNode;
  children?: React.ReactNode;
  // optional controlled config. If provided, the component will become a controlled component.
  controlledConfig?: {
    onToggle: (expanded: boolean) => void;
    expanded: boolean;
  };
}

export default function AccordionSection({
  title,
  children,
  controlledConfig,
}: AccordionSectionProps) {
  const [selfExpanded, setSelfExpanded] = useState(false);
  const expanded = controlledConfig?.expanded ?? selfExpanded;
  return (
    <div className="m-claim--w-full m-claim--overflow-hidden m-claim--rounded-md">
      <div
        className="m-claim--w-full"
        onClick={() =>
          controlledConfig?.onToggle
            ? controlledConfig.onToggle(!controlledConfig.expanded)
            : setSelfExpanded(!selfExpanded)
        }
      >
        {typeof title === 'string' ? (
          <div className="m-claim--group m-claim--mb-4 m-claim--inline-flex m-claim--w-full m-claim--cursor-pointer m-claim--items-center m-claim--justify-between m-claim--self-stretch m-claim--p-2">
            <div className="m-claim--w-full  m-claim--font-semimono m-claim--text-xs m-claim--font-normal m-claim--uppercase m-claim--leading-snug m-claim--text-secondary m-claim--transition-colors group-hover:m-claim--text-primary">
              {title}
            </div>
            <div
              data-svg-wrapper
              className={`m-claim--relative m-claim--transition-transform m-claim--duration-300 ${
                expanded ? 'm-claim--rotate-180' : ''
              }`}
            >
              <img
                height={18}
                width={18}
                src={MChevronDownIcon}
                alt="Toggle Section"
              />
            </div>
          </div>
        ) : (
          title
        )}
      </div>

      <div
        className={`m-claim--transition-[max-height,opacity] m-claim--duration-300 m-claim--ease-in-out ${
          expanded
            ? 'm-claim--max-h-[400px] m-claim--opacity-100'
            : 'm-claim--max-h-0 m-claim--opacity-0'
        }`}
      >
        {children}
      </div>
    </div>
  );
}
